import {
  fetchGenericTreeData,
  mapDepts,
  runFetchAxios,
  hasAllTreeAuth,
  encodeKey
} from '../query-table/utils'

export default {
  props: {
    auth: { // 是否走权限api（包含白名单）
      type: Boolean,
      default: false
    },
    accordion: {
      type: Boolean,
      default: true
    },
    hasAllTreeAuth: { // 模糊搜索是否不走权限接口的数据，不替换原有树，仅做查找
      type: Boolean,
      default: false
    },
    fetchData: Function,
    filterData: Function,
    formatResult: Function,
    searchUrl: String,
    searchParams: Function,
    searchResultUrl: String,
    axios: { // axios
      type: Object,
      default: () => ({})
    },
    disabledCache: { // 是否禁用缓存，如果为false，每次打开弹框时都调用接口
      type: Boolean,
      default: true
    },
    fetchAxios: Function, // 获取历史月份组织参数 { data: {bakMonth: '2020-01'}, ...其他属性为 http 方法第三个参数为对象时的属性，比如{cancel,log,axios} }
    defaultExpandedKeys: Array, // 默认展开项
    checkNodeSelect: Function, // 检查当前节点是否可被选择
    historyId: String // 配合输入框的历史记录功能, 实现xPath不能区分节点, 添加指定的historyId确认唯一性
  },
  data () {
    return {
      load: false,
      init: false,
      bakMonth: '',
      departmentId: '',
      authTree: [],
    }
  },
  computed: {
    bakMonthLabel () {
      return this.bakMonth ? `历史数据：${this.bakMonth}` : '实时数据'
    },
    searchDeptUrl () {
      let url = this.searchUrl
      return url || (this.bakMonth ? 'hr.departmentBak.getByFuzzyValue' : 'hr.department.refactoring.getByFuzzyValue')
    },
    threeLevelTreeUrl () {
      let url = this.searchResultUrl ? this.searchResultUrl : 'hr.department.refactoring.getThreeLevelAsTree'
      return this.bakMonth ? 'hr.departmentBak.getThreeLevelAsTree' : url
    },
    expandedKeys () {
      const { defaultExpandedKeys } = this.$props
      if (defaultExpandedKeys) {
        return defaultExpandedKeys
      }
      const [row] = this.authTree || []
      const { id } = row || {}
      const ids = [id, this.departmentId].filter(id => id)
      return ids
    },
  },
  methods: {
    initTree () {
      // 历史组织数据
      const attrs = { fetchAxios: this.fetchAxios }
      const bakMonthConf = runFetchAxios(attrs)
      let cacheKey = ''
      let hasBakMonth = false
      this.bakMonthCache = this.bakMonthCache || {}
      if (bakMonthConf) {
        cacheKey = encodeKey(JSON.stringify(bakMonthConf.data))
        hasBakMonth = this.disabledCache && this.bakMonthCache[cacheKey]
        this.bakMonth = bakMonthConf.data.bakMonth
      } else {
        this.bakMonth = ''
      }

      let needReq = !this.authTree.length || (bakMonthConf && !hasBakMonth) || !this.disabledCache
      if (needReq) {
        const allTreeAuth = this.hasAllTreeAuth
        const auth = this.auth
        const fetchData = this.fetchData

        // this.show = true
        this.load = true
        this.hasAllTree = hasAllTreeAuth() || allTreeAuth

        const promise = fetchData ? fetchData() : fetchGenericTreeData(auth, attrs, this.axios, allTreeAuth)
        promise
          .then(async res => {
            if (!res || !res.id || !res.parentId || !res.children) {
              this.init = true
              this.load = false
              return
            }

            // 缓存历史数据
            if (this.bakMonth && this.disabledCache) {
              this.bakMonthCache[cacheKey] = res
            }

            // 过滤节点
            const filterData = this.filterData
            if (filterData) {
              let func = Promise.resolve(filterData(res))
              res = await func
            }
            this.initData(res, this.hasAllTree && !fetchData && !auth && !this.bakMonth)
            this.init = false
            this.load = false
            // this.collapseLevel2(field)
          })
          .catch(e => {
            this.load = false
            throw e
          })
      } else {
        // this.show = true
        // this.collapseLevel2(field)
      }
    },
    // 初始化数据
    initData (data, all) {
      const isArray = Array.isArray(data)
      const Root = {
        id: 'root',
        children: data
      }
      if (all) {
        this.deptMap = this.$store.state.orgTree.deptMap || {}
        this.authTree = isArray ? [...data] : [data]
      } else {
        if (isArray) {
          // 如果是数组则需要本地模拟顶层节点
          this.deptMap = mapDepts({}, Root, Root.children)
          this.authTree = [...data]
        } else {
          this.deptMap = mapDepts({}, data, data.children)
          this.authTree = [data]
          this.departmentId && this.setCheckedDept(this.departmentId)
        }
      }
    },
    // 搜索部门
    searchDeptParams (val) {
      if (this.searchParams && typeof this.searchParams === 'function') {
        return this.searchParams(val)
      }
      return this.bakMonth ? { fuzzyValue: val, bakMonth: this.bakMonth } : { fuzzyValue: val }
    },
    chooseDepartment (item) {
      const isNext = this._checkNodeSelect(item)
      if (isNext === false) {
        return this.$nextTick(() => this.departmentName = '')
      }

      let id = item.id
      this.init = false
      this.departmentId = id
      if (this.hasAllTree) {
        this.$refs.deptTree.filterTree(id)
      } else {
        this.filterTree(id)
      }
    },
    filterTree (id) {
      let params = this.bakMonth ? { id, bakMonth: this.bakMonth } : { id }
      this.$http(this.threeLevelTreeUrl, params, this.axios).then(this.initData)
    },
    setCheckedDept (id) {
      this.$nextTick(_ => {
        // 定位
        this.$refs.deptTree.setCheckedDept(id)
      })
    },
    focus () {
      this.$refs.searchTips && this.$refs.searchTips.focus()
    },
    _checkNodeSelect(item) {
      const isNext = typeof this.checkNodeSelect === 'function' ? this.checkNodeSelect(item) : true
      return isNext
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-dept/mixins.js